<div class="content-section" [ngClass]="{ 'expand' : layoutService.expandedMenu }">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div *ngIf="showTabs" class="title-section title-bar title-bar-nav">
        <div class="title-div">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-11 p-0">
                        <h2 class="background_title">{{ translationKeys.LayoutModule.Observe | translate }}</h2>
                    </div>
                </div>
        </div>
        <div class="container-nav">
            <nav class="nav nav-pills nav-title">
                <a *ngIf="appConfig.userData.roleName.roleId > 3" class="nav-link " routerLink="/observe/newObserve" routerLinkActive='active'>{{ 'CONFIGURE.OBSERVATION' |
                    translate }}</a>
                <a *ngIf="appConfig.userData.roleName.roleId > 3" class="nav-link" routerLink="/observe/observeObservationProtocol" routerLinkActive='active'>{{
                    translationKeys.SOPObservation.ObservationProtocol | translate }}</a>
                <a *ngIf="(canShowQuota) && (appConfig.userData) && (appConfig.userData.roleName.roleId == 3 || appConfig.userData.roleName.roleId == 4)"
                     class="nav-link" routerLink="/observe/managequota" routerLinkActive='active'>{{ translationKeys.Configure.Quota | translate }}</a>

            </nav>
            <hr class="nav-separator">
        </div>
    </div>

    <div [ngClass]="{'observe-navigation container-section-nav': showTabs}">
        <router-outlet></router-outlet>
    </div>
</div>
<ng-template #template>
    <div class="modal-header justify-content-between align-items-center">
        <!-- <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.UserProfiles.SelectInsititutions | translate }}
        </h5> -->
        <a class="cursor" aria-label="Close" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar class="change-lang">
        <div [formGroup]="mygroup" class="col-12">
            <div class="mb-2 form-check" *ngFor='let Institutions of InstitutionsList;let i = index'>
                <input type="radio" [value]="Institutions.institution.institutionID" name="selectedIns" *ngIf="showInstitutionDropDown()" formControlName="selectedIns" class="form-check-input" id={{Institutions.institution.institutionID}}>
                <label class="form-check-label" for={{Institutions.institution.institutionID}}>{{Institutions.institution.institutionName | labelSanitizer}}</label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 my-3">
                    <button type="button" class="btn btn-block btn-primary" (click)="modalRef.hide();onInstitutionChange(mygroup.value.selectedIns);">{{
                        translationKeys.Authorization.Done | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
